import { z } from 'zod';

export const poFileUploadSchema = z.object({
	processObjectId: z
		.string({ message: 'A process object ID must be selected.' })
		.trim()
		.nonempty({ message: 'A process object ID must be selected.' }),
	title: z.string().trim().optional().default(''),
	description: z
		.string({ message: 'Description is required.' })
		.trim()
		.nonempty({ message: 'The description must contan at least 1 character' }),
	files: z.preprocess(
		val => (Array.isArray(val) ? val : val == null ? [] : [val]),
		z.array(z.instanceof(File, { message: 'A valid file must be uploaded.' })).min(1, 'At least one file must be uploaded.')
	)
});

export type UploadProcessObjectFileFormSchema = z.infer<typeof poFileUploadSchema>;

export const poFileUpdateSchema = z.object({
	file: z.instanceof(File, { message: 'A valid file must be uploaded.' }).optional()
}).refine(data => data.file != null, { message: 'A valid file must be uploaded.', path: ['file'] });

export type UpdateProcessObjectFileFormSchema = z.infer<typeof poFileUpdateSchema>;
